import { enumParser } from '#validation/common/parsers';
import { MemberScimStatus, MemberStatus } from '../constants';
export const memberStatusParser = enumParser(MemberStatus);
export const memberScimStatusParser = enumParser(MemberScimStatus);
